export default __webpack_public_path__ + "static/media/EP08_ERYTHREE.af9d67db.mp3";